import { Config } from '@backstage/config';
import {
  AnalyticsApi,
  AnalyticsEvent,
  BackstageUserIdentity,
  IdentityApi,
} from '@backstage/core-plugin-api';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export class AzureApplicationInsights implements AnalyticsApi {
  private appInsights: ApplicationInsights;
  private identityApi: IdentityApi;
  private identity: BackstageUserIdentity | null;

  private constructor(options: {
    connectionString: string;
    identityApi: IdentityApi;
  }) {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: options.connectionString,
      },
    });
    this.appInsights.loadAppInsights();
    this.identityApi = options.identityApi;
    this.identity = null;
  }

  public static fromConfig(
    config: Config,
    options: {
      identityApi: IdentityApi;
    },
  ): AzureApplicationInsights {
    const connectionString = config.getString(
      'app.analytics.azureApplicationInsights.connectionString',
    );

    return new AzureApplicationInsights({
      ...options,
      connectionString,
    });
  }

  public async captureEvent(event: AnalyticsEvent) {
    const identity =
      this.identity ??
      (this.identity = await this.identityApi.getBackstageIdentity());

    this.appInsights.trackEvent({
      name: event.action,
      properties: {
        subject: event.subject,
        value: event.value,
        user: identity.userEntityRef,
      },
    });
  }
}
